import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page35/Key/E2answerKey.png",

    titleQuestion: [
      {
        num: "2",
        title: "Khoanh vào chữ đặt trước câu trả lời đúng.",
        color: "rgb(99,197,244)",
      },
    ],
    
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chữ đặt dưới câu trả lời đúng.</span>
                <video src="Audios/bt_fpt_ai/guide/p35_e2.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    component: Circle_Write,
    inputSize: 70,
    questionImage: [],
    stylesTextInput: {
      textAlign: "center",
      fontSize: 23,
    },
    question: {
      Write: {
        isHiddenCheck: true,
        inputStyle: {
          width: 100,
          fontSize: 22,
          textAlign: "center",
          maxLength: 1,
          fontWeight: 700,
        },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          borderRadius: "50%",
          fontWeight: "bold",
          borderColor: "transparent",
          border: "2px solid white",
          padding: "0px 4px",
        },
        selectWordStyle: {
          padding: "0px 4px",
          border: "2px solid black",
        },
        limitSelect: 1,
        listWords: [
          `A &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
       B &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
       C &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
       D
       `, //1
        ],
        answers: ["0-36"],
        initialValue: [],
      },
      Layout: `
      
        <div style= "">
           Hoàng Hậu hẹn Thỏ Trắng đến dự tiệc trà. Biết tiệc trà bắt đầu lúc kim giờ và kim phút
           tạo thành một góc bẹt. Hỏi trong các đồng hồ dưới đây, đòng hồ nào chỉ lúc tiệc bắt đầu?
        </div>
        <img src='/img/FriendsPlus/Page35/E2/1.jpg' style= "width: 25cm; margin-left: -30px; margin-bottom: -25px; margin-top: 20px"/>
        <div style= "margin-left: 83px; margin-top: 30px"><input id='0' type='Circle'/></div>
    `,
    },
  },

  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page35/Key/E3answerKey.jpg",
    component: T6,
    isHiddenCheck: true,
    titleQuestion: [
      {
        num: "3",
        title: `Viết số đo góc thích hợp vào chỗ chấm.<br>
        Để đo chiều cao một cái cây, người ta xác định 3 điểm O,A và B như trong hình vẽ dưới đây.
        `,
        color: "rgb(99,197,244)",
      },
    ],
    
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Di chuyển thước vào các góc trong hình để đo rồi nháy chuột vào chỗ chấm để viết số đo.</span>
                <video src="Audios/bt_fpt_ai/guide/p35_e3.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "106px",
        inputTop: "350px",
        ResultProtractor:[
          {
            textResult: 60,
            styleResult:{
              top: -283,
              left:630
            }
          },
          {
            textResult: 60,
            styleResult:{
              top:-92,
              left:737
            },
          },
          {
            textResult: 90,
            styleResult:{
              top:-311,
              left:636
            }
          },
          {
            textResult: 90,
            styleResult:{
              top:-92,
              left:415
            },
          },
          
        ],
        result: [
          //Đỉnh B
          {
            id: 0,
            top: 69, // top cây thước sau khi đặt vô hình
            left: 443, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 1,
            top: 67, // top cây thước sau khi đặt vô hình
            left: 438, // left cây thước sau khi đặt vô hình
            rotate: 121,
          },
          //Đỉnh A
          {
            id: 2,
            top: 69, // top cây thước sau khi đặt vô hình
            left: 562, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 3,
            top: 71, // top cây thước sau khi đặt vô hình
            left: 564, // left cây thước sau khi đặt vô hình
            rotate: -90,
          },
        ],
      },
    ],
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800 },
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style="position: relative; top: -49px; left: 444px">
        <img src="/img/FriendsPlus/Page35/E3/1.jpg"  style="height:9cm; margin-top:50px; position:absolute; top:0px; left:-89px" >

        <div
          style="
            position: absolute;
            left: 191px;
            top: 292px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
          <div
          style="
            position: absolute;
            left: 311px;
            top: 293px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            z-index:1
          "
          ></div>
      </div>
      <div
          id="protractor"
          style="position: absolute;top: 127px;left: 7px;width: 400px; height: 420px;z-index: 1"
        >
        <img
        src="/img/test/protractor-removebg-preview3.png"
        style="width: 400px"
        alt="image"
      />
        </div>

      <div style='width: 1000px; height: 500px; margin-bottom: 180px'>
      <div style='margin-top: 30px; line-height: 50px'>
      	<span style=''>Góc đỉnh B; cạnh BA, BO bằng <input id= "0"><sup>o</sup></span><br>
      	<span style=''>Góc đỉnh A; cạnh AB, AO bằng <input id= "1"><sup>o</sup></span><br>
      </div>
      </div>
        `,
        answer: ["60", "90"],
      },
    ],
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page35/Key/E4answerKey.png",

    titleQuestion: [
      {
        num: "4",
        title: "Viết số thích hợp vào chỗ chấm.",
        color: "rgb(99,197,244)",
      },
    ],
    
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Đếm số góc có trong hình và nháy chuột vào chỗ chấm để điền số góc.</span>
                <video src="Audios/bt_fpt_ai/guide/p35_e4.mp3" controls style="width: 100%; height: 2cm"></video>     
        `,
      },
    ],
    component: T6,
    isHiddenCheck: true,
    titleImage: "",
    inputSize: 90,
    // isAllowSubmit: false,
    questionImage: [],
    maxLength: 10,
    stylesTextInput: {
      textAlign: "center",
      fontSize: 24,
      borderBottom: "2px dotted black",
      height: 22,
    },
    questions: [
      {
        title: `
			<img src='/img/FriendsPlus/Page35/E4/1.jpg' style='height: 8cm; margin-bottom: 20px; margin-left: 150px'/> <br>
		  <div style= "margin-left: -35px">
        <span>Trong hình trên có </span>
        <input id= "0">
        <span> góc nhọn, </span>
        <input id= "1">
        <span> góc vuông và</span>
        <input id= "2">
        <span> góc tù.</span>
      </div>
			`,
        answer: [`18`, `24`, `30`],
      },
    ],
  },
};

export default json;
